exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.md-drawer[data-v-7ba5bd90] {\r\n    width: 230px;\r\n    max-width: calc(100vw - 125px);\n}\r\n\r\n\r\n", ""]);

// exports
